import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ index, eyebrow, title, testId }) {
  return (
    <Reveal>
      <p className="mb-4 font-vt text-xl tracking-[0.15em] text-neon sm:text-2xl">
        {"//"} {index} — {eyebrow}
      </p>
      <h2
        data-testid={testId}
        className="glitch-hover font-display text-3xl font-extrabold tracking-tight text-[#EDEDE4] uppercase sm:text-4xl lg:text-5xl"
      >
        {title}
      </h2>
    </Reveal>
  );
}
